<!-- header -->
<h2 class="desktop-only" [innerHtml]="slide.title"></h2>

<!-- image -->
<image-quiz
    [slide]="slide">
</image-quiz>

<!-- header -->
<h2 class="mobile-only" [innerHtml]="slide.title"></h2>

<ul class="answers cf">
    <li class="answer" *ngFor="let a of slide.content; trackBy: utils.trackByIndex">
        <span [innerHtml]="a.text"></span>
    </li>
</ul>

<!-- progress -->
<div class="progress"><a class="bar primary-background" #progress></a><span class="percent ">{{getProgress(i)}}%</span></div>
